<template>
  <span>{{ date }}, van {{ startTime }} - {{ endTime }} uur</span>
</template>

<script setup>
import dayjs from 'dayjs';

const props = defineProps({
  times: {
    type: Object,
    required: true,
  },
});

const date = computed(() => {
  const formattedDate = dayjs(props.times.start_date_time).format(
    'dddd D MMMM'
  );
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
});

const startTime = computed(() => {
  return dayjs(props.times.start_date_time).format('HH:mm');
});

const endTime = computed(() => {
  return dayjs(props.times.end_date_time).format('HH:mm');
});
</script>

<style lang="scss" scoped></style>
